
import { FETCH_ALL_PURCHASES, ADD_NEW_PURCHASE, UPDATE_PURCHASE, DELETE_PURCHASE, SOFTDELETE_PURCHASE, FETCH_DELETED_PURCHASES, GET_PURCHASE, START_LOADING, END_LOADING, FETCH_PURCHASE_BY_USER } from '../actions/constants'

const purchases = (state = { isLoading: true, purchases: [], deletedPurchases: [] }, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true };
      case END_LOADING:
        return { ...state, isLoading: false };
      case FETCH_ALL_PURCHASES:
        return {
          ...state,
          purchases: action.payload,
          currentPage: action.payload.currentPage,
          numberOfPages: action.payload.numberOfPages,
        };
      case FETCH_PURCHASE_BY_USER:
        return { ...state, purchases: action.payload };

      case GET_PURCHASE:
        return { ...state, purchase: action.payload };
      case ADD_NEW_PURCHASE:
        // Prepended: getPurchases sorts newest-first ({_id:-1}).
        return { ...state, purchases: [action.payload, ...state.purchases] };
      case UPDATE_PURCHASE:
        return {
          ...state,
          purchases: state.purchases.map((purchase) => (purchase._id === action.payload._id ? action.payload : purchase)),
          // Same fix as reducers/invoices.js: without this, PurchaseDetails.js
          // (which reads state.purchases.purchase, set by GET_PURCHASE) kept
          // showing stale data after recording a payment here, even though
          // the list itself updated correctly.
          purchase: state.purchase?._id === action.payload._id ? action.payload : state.purchase,
        };
      case DELETE_PURCHASE:
        return { ...state, purchases: state.purchases.filter((purchase) => purchase._id !== action.payload) };
      case SOFTDELETE_PURCHASE:
        return { ...state, purchases: state.purchases.filter((purchase) => purchase._id !== action.payload) };
      case FETCH_DELETED_PURCHASES:
        return { ...state, deletedPurchases: action.payload };
      default:
        return state;
    }
  };

  export default purchases

